export default __webpack_public_path__ + "static/media/logo.262452c0.png";